import { FC, useState } from 'react';
// import { UserOutlined } from '@ant-design/icons';
import { useAuthContext } from 'context/AuthContext';
import { type MenuProps, Button, Drawer, Menu } from 'antd';
import { useRouteContext } from 'context/RouteContext';
import { MenuOutlined } from '@ant-design/icons';

interface Props {
  items: MenuProps['items'];
}

const MenuMobile: FC<Props> = ({ items }) => {
  const { user } = useAuthContext();
  const [open, setOpen] = useState(false);
  const { setPath } = useRouteContext();

  const onClick: MenuProps['onClick'] = (e) => {
    console.log('click', e);
    onClose();
    setPath(e.key);
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button type="link" onClick={showDrawer}>
        <MenuOutlined />
      </Button>
      <Drawer title={`Hello, ${user?.firstname}`} onClose={onClose} open={open}>
        <Menu
          onClick={onClick}
          // style={{ width: 256 }}
          mode="vertical"
          items={items}
        />
      </Drawer>
    </>
  );
};

export { MenuMobile };
